import { useState } from "react";
import Tabs from "../../../components/ui/Tabs";
import PersonalSection from "../sections/PersonalSection";
import AddressesSection from "../sections/AddressesSection";
import ContactsSection from "../sections/ContactsSection";
import GovernmentIdsSection from "../sections/GovernmentIdsSection";
import EducationSection from "../sections/EducationSection";
import EmploymentHistorySection from "../sections/EmploymentHistorySection";
import EmploymentSection from "../sections/EmploymentSection";
import styles from "../Profile.module.css";

const TABS = [
  { id: "personal", label: "Personal" },
  { id: "addresses", label: "Addresses" },
  { id: "contacts", label: "Contacts" },
  { id: "government", label: "Government IDs" },
  { id: "education", label: "Education" },
  { id: "history", label: "Employment History" },
  { id: "employment", label: "Employment" },
];

// `record` is the GET /employee/me response.
const ProfileTabs = ({ record }) => {
  const [tab, setTab] = useState("personal");

  const content = {
    personal: (
      <PersonalSection
        profile={record.profile}
        personalDetails={record.personalDetails}
      />
    ),
    addresses: <AddressesSection addresses={record.addresses ?? []} />,
    contacts: (
      <ContactsSection
        contacts={record.contacts ?? []}
        emergencyContacts={record.emergencyContacts ?? []}
      />
    ),
    government: (
      <GovernmentIdsSection documents={record.governmentDocuments ?? []} />
    ),
    education: <EducationSection education={record.education ?? []} />,
    history: (
      <EmploymentHistorySection history={record.employmentHistory ?? []} />
    ),
    employment: <EmploymentSection profile={record.profile} />,
  };

  return (
    <>
      <Tabs tabs={TABS} active={tab} onChange={setTab} />
      <div className={styles.tabBody}>{content[tab]}</div>
    </>
  );
};

export default ProfileTabs;
